import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.scss";
import logo from "../../assets/logoavena.svg";

const API = "https://api.ainfotech.com.np";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // "products" | "services" | "web" | null
  const [mobileSub, setMobileSub] = useState(null);       // "products" | "services" | "web" | null
  const navigate = useNavigate();

  // Data
  const [prodCats, setProdCats] = useState([]);
  const [services, setServices] = useState([]);
  const [webs, setWebs] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/api/products/categories`);
        const j = await r.json();
        setProdCats(Array.isArray(j) ? j : []);
      } catch {
        setProdCats([]);
      }
    })();

    (async () => {
      try {
        const r = await fetch(`${API}/api/services?status=published&page=1&limit=50`);
        const j = await r.json();
        setServices(Array.isArray(j.items) ? j.items : []);
      } catch {
        setServices([]);
      }
    })();

    (async () => {
      try {
        const r = await fetch(`${API}/api/websolutions?status=published&page=1&limit=50`);
        const j = await r.json();
        setWebs(Array.isArray(j.items) ? j.items : []);
      } catch {
        setWebs([]);
      }
    })();
  }, []);

  const closeMobile = () => {
    setMobileOpen(false);
    setMobileSub(null);
  };
  const closeDropdowns = () => setOpenDropdown(null);

  const goProductsCategory = (slug) => {
    closeDropdowns();
    navigate(`/productpage?group=${encodeURIComponent(slug)}`);
  };
  const goService = (slug) => {
    closeDropdowns();
    navigate(`/services/${slug}`);
  };
  const goWebSolution = (slug) => {
    closeDropdowns();
    navigate(`/websolutions/${slug}`);
  };

  return (
    <header className="avena-navbar">
      {/* ===== TOP BAR ===== */}
      <div className="avena-navbar__topbar">
        <div className="container d-flex align-items-center justify-content-between">
          <Link to="/" className="avena-navbar__brand d-flex align-items-center" aria-label="Home">
            <img src={logo} alt="Avena Info Tech" className="avena-navbar__logo" />
          </Link>

          <nav className="avena-navbar__menu d-none d-lg-flex align-items-center">
            {/* <ul className="list-unstyled d-flex align-items-center mb-0 avena-navbar__menu-list">
              <li><Link to="/news" className="avena-navbar__link">Events &amp; Media</Link></li>
              <li><Link to="/blog" className="avena-navbar__link">Blog</Link></li>
              <li><Link to="/careers" className="avena-navbar__link">Careers</Link></li>
            </ul> */}
            <Link to="/contact" className="avena-navbar__cta ms-4">CONNECT WITH US</Link>
          </nav>

          <button
            className="avena-navbar__toggler d-lg-none"
            type="button"
            aria-expanded={mobileOpen}
            aria-controls="avena-mobile"
            aria-label="Toggle navigation"
            onClick={() => setMobileOpen(v => !v)}
          >
            <span className="avena-navbar__toggler-icon" />
          </button>
        </div>

        {/* ===== MOBILE DRAWER ===== */}
        <div
          id="avena-mobile"
          className={`avena-navbar__mobile ${mobileOpen ? "show" : ""}`}
          role="dialog"
          aria-modal="true"
        >
          <div className="container">
            <ul className="list-unstyled mb-3 avena-mobile__list">
              <li><Link to="/" onClick={closeMobile}>Home</Link></li>
              <li><Link to="/about" onClick={closeMobile}>About</Link></li>

              {/* Products (mobile): link + separate chevron toggle */}
              <li className={`avena-mobile__accordion ${mobileSub === "products" ? "open" : ""}`}>
                <div className="avena-mobile__accordion-head">
                  <Link
                    to="/productpage"
                    className="avena-mobile__accordion-link"
                    onClick={closeMobile}
                  >
                    Products
                  </Link>
                  <button
                    type="button"
                    className="avena-mobile__accordion-toggle"
                    aria-expanded={mobileSub === "products"}
                    onClick={() => setMobileSub(mobileSub === "products" ? null : "products")}
                    aria-label="Toggle Products submenu"
                  >
                    <span className="chev" aria-hidden="true" />
                  </button>
                </div>

                <ul className="avena-mobile__submenu list-unstyled">
                  {prodCats.map((c) => (
                    <li key={c.id}>
                      <Link to={`/productpage?group=${encodeURIComponent(c.slug)}`} onClick={closeMobile}>
                        {c.name}
                      </Link>
                    </li>
                  ))}
                  {prodCats.length === 0 && <li><span className="text-muted">No categories</span></li>}
                </ul>
              </li>

              {/* Services (mobile): link + separate chevron toggle */}
              <li className={`avena-mobile__accordion ${mobileSub === "services" ? "open" : ""}`}>
                <div className="avena-mobile__accordion-head">
                  <Link
                    to="/servicespage"
                    className="avena-mobile__accordion-link"
                    onClick={closeMobile}
                  >
                    Services
                  </Link>
                  <button
                    type="button"
                    className="avena-mobile__accordion-toggle"
                    aria-expanded={mobileSub === "services"}
                    onClick={() => setMobileSub(mobileSub === "services" ? null : "services")}
                    aria-label="Toggle Services submenu"
                  >
                    <span className="chev" aria-hidden="true" />
                  </button>
                </div>

                <ul className="avena-mobile__submenu list-unstyled">
                  {services.map((s) => (
                    <li key={s.id}>
                      <Link to={`/services/${s.slug}`} onClick={closeMobile}>
                        {s.title}
                      </Link>
                    </li>
                  ))}
                  {services.length === 0 && <li><span className="text-muted">No services</span></li>}
                </ul>
              </li>

              {/* Web Solutions (mobile): link + separate chevron toggle */}
              <li className={`avena-mobile__accordion ${mobileSub === "web" ? "open" : ""}`}>
                <div className="avena-mobile__accordion-head">
                  <Link
                    to="/websolutionspage"
                    className="avena-mobile__accordion-link"
                    onClick={closeMobile}
                  >
                    Web Solutions
                  </Link>
                  <button
                    type="button"
                    className="avena-mobile__accordion-toggle"
                    aria-expanded={mobileSub === "web"}
                    onClick={() => setMobileSub(mobileSub === "web" ? null : "web")}
                    aria-label="Toggle Web Solutions submenu"
                  >
                    <span className="chev" aria-hidden="true" />
                  </button>
                </div>

                <ul className="avena-mobile__submenu list-unstyled">
                  {webs.map((w) => (
                    <li key={w.id}>
                      <Link to={`/websolutions/${w.slug}`} onClick={closeMobile}>
                        {w.title}
                      </Link>
                    </li>
                  ))}
                  {webs.length === 0 && <li><span className="text-muted">No items</span></li>}
                </ul>
              </li>

              <li><Link to="/news" onClick={closeMobile}>Events &amp; Media</Link></li>
              <li><Link to="/blog" onClick={closeMobile}>Blog</Link></li>
              <li><Link to="/careers" onClick={closeMobile}>Careers</Link></li>

              <li className="mt-3">
                <Link to="/contact" className="btn avena-navbar__cta w-100" onClick={closeMobile}>
                  CONNECT WITH US
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ===== BOTTOM BAR (desktop): dropdowns show names only ===== */}
      <div className="avena-navbar__bottombar d-none d-lg-block">
        <div className="container">
          <div className="row align-items-center">
            <div className="col">
              <nav aria-label="Secondary">
                <ul className="avena-navbar__secondary list-unstyled d-flex align-items-center mb-0">
                  <li className="nav-item avena-navbar__secondary-item">
                    <Link className="nav-link avena-navbar__secondary-link" to="/" onClick={closeDropdowns}>Home</Link>
                  </li>
                  <li className="nav-item avena-navbar__secondary-item">
                    <Link className="nav-link avena-navbar__secondary-link" to="/about" onClick={closeDropdowns}>About</Link>
                  </li>

                  {/* Products dropdown: names only */}
                  <li
                    className={`nav-item dropdown avena-navbar__secondary-item avena-hover-parent ${openDropdown === "products" ? "show" : ""}`}
                    onMouseEnter={() => setOpenDropdown("products")}
                    onMouseLeave={closeDropdowns}
                  >
                    <button
                      type="button"
                      className="nav-link avena-navbar__secondary-link dropdown-toggle"
                      aria-expanded={openDropdown === "products"}
                    >
                      Products
                    </button>
                    <ul className={`dropdown-menu avena-dropdown ${openDropdown === "products" ? "show" : ""}`}>
                      {prodCats.map((c) => (
                        <li key={c.id}>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => goProductsCategory(c.slug)}
                          >
                            {c.name}
                          </button>
                        </li>
                      ))}
                      {prodCats.length === 0 && (
                        <li><span className="dropdown-item text-muted">No categories</span></li>
                      )}
                    </ul>
                  </li>

                  {/* Services dropdown: names only */}
                  <li
                    className={`nav-item dropdown avena-navbar__secondary-item avena-hover-parent ${openDropdown === "services" ? "show" : ""}`}
                    onMouseEnter={() => setOpenDropdown("services")}
                    onMouseLeave={closeDropdowns}
                  >
                    <Link to="/servicespage" className="nav-link avena-navbar__secondary-link dropdown-toggle" aria-expanded={openDropdown === "services"}>
                      Services
                    </Link>
                    <ul className={`dropdown-menu avena-dropdown ${openDropdown === "services" ? "show" : ""}`}>
                      {services.map((s) => (
                        <li key={s.id}>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => goService(s.slug)}
                          >
                            {s.title}
                          </button>
                        </li>
                      ))}
                      {services.length === 0 && (
                        <li><span className="dropdown-item text-muted">No services</span></li>
                      )}
                    </ul>
                  </li>

                  {/* Web Solutions dropdown: names only */}
                  <li
                    className={`nav-item dropdown avena-navbar__secondary-item avena-hover-parent ${openDropdown === "web" ? "show" : ""}`}
                    onMouseEnter={() => setOpenDropdown("web")}
                    onMouseLeave={closeDropdowns}
                  >
                    <Link to="/websolutionspage" className="nav-link avena-navbar__secondary-link dropdown-toggle" aria-expanded={openDropdown === "web"}>
                      Web Solutions
                    </Link>
                    <ul className={`dropdown-menu avena-dropdown ${openDropdown === "web" ? "show" : ""}`}>
                      {webs.map((w) => (
                        <li key={w.id}>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => goWebSolution(w.slug)}
                          >
                            {w.title}
                          </button>
                        </li>
                      ))}
                      {webs.length === 0 && (
                        <li><span className="dropdown-item text-muted">No items</span></li>
                      )}
                    </ul>
                  </li>
                  <li className="nav-item avena-navbar__secondary-item">
                    <Link className="nav-link avena-navbar__secondary-link" to="/news" onClick={closeDropdowns}>Events & Media</Link>
                  </li>
               <li className="nav-item avena-navbar__secondary-item">
                    <Link className="nav-link avena-navbar__secondary-link" to="/blog" onClick={closeDropdowns}>Blog</Link>
                  </li>
          <li className="nav-item avena-navbar__secondary-item">
                    <Link className="nav-link avena-navbar__secondary-link" to="/careers" onClick={closeDropdowns}>Careers</Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
